export const positionAlignmentRoute = {
    patterns: {
        me: '/workplace/me/alignment',
        team: '/workplace/team/alignment',
    },
    searchParams: {
        automation: 'automation',
        step: 'step',
        /** A comment thread a link points at, focused in the comments. */
        thread: 'thread',
    },
} as const;
